module.exports = __webpack_public_path__ + "img/confg_orari_smartbook.4b9bdc97.png";